export function getProjectNameFromUrl(url: string): string | undefined {
  return url.match(/\/project\/\d+\/([^\/?]+)/)?.[1];
}
